import { useCallback, useContext, useMemo } from "react";
import { ThemeContext } from "../Contexts/Theme";

export const useColorMode = () => {
  const [mode, dispatch] = useContext(ThemeContext);

  const isDark = mode === "dark";

  const setMode = useCallback(
    (nextMode) => {
      if (nextMode !== "dark" && nextMode !== "light") return;
      dispatch({ type: "setUserTheme", userTheme: nextMode });
    },
    [dispatch]
  );

  const toggle = useCallback(() => {
    dispatch({
      type: "setUserTheme",
      userTheme: isDark ? "light" : "dark",
    });
  }, [dispatch, isDark]);

  return useMemo(
    () => ({
      mode: mode || "light",
      isDark,
      setMode,
      toggle,
    }),
    [mode, isDark, setMode, toggle]
  );
};
